import { observer } from "mobx-react-lite";
import { useParams } from "react-router-dom";
import { useTran } from "@/hooks";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useManageUserPageData } from "../hooks";
import ManageUserForm from "./ManageUserForm";
import ManageUserFooter from "./ManageUserFooter";

const ManageUserCard = observer(() => {
  const { t } = useTran();
  const { userId } = useParams();
  const { displayLabel, loading, errorMessage } = useManageUserPageData({
    userId,
  });

  const showFooter = Boolean(userId && !loading && !errorMessage);

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Manage User")}</CardTitle>
        <CardDescription>
          {displayLabel
            ? t("Update settings for {{user}}", { user: displayLabel })
            : t("Update user details, status, and access.")}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ManageUserForm />
      </CardContent>
      {showFooter ? <ManageUserFooter /> : null}
    </Card>
  );
});

export default ManageUserCard;
